import Message from './Message';

export default Message;
export * as MessageStyles from './Message.styles';
export * as MessageTypes from './Message.types';
